import { Component, OnInit } from '@angular/core';
import { RapportService } from 'src/app/_services/rapport/rapport.service';

@Component({
  selector: 'app-rapport-front',
  templateUrl: './rapport-front.component.html',
  styleUrls: ['./rapport-front.component.css']
})
export class RapportFrontComponent implements OnInit {

  constructor(private RapportService  : RapportService) { } 
  rapport : any[]=[];
  ngOnInit(): void {this.afficheRapport();}

  afficheRapport() {
    this.RapportService.afficherRapport().subscribe(res => {
      this.rapport = res;
    });
  }
}
